import { httpClient } from "../http/httpClient";
import { PanLinkResponse } from "../panService/getLink";

export async function getLinkFormalize(id: string) {
  const { data } = await httpClient.get<PanLinkResponse>(
    `/self-hire/transaction/${id}/link`,
  );
  return data;
}
